import {
    Avatar as ChakraAvatar,
    AvatarProps as ChakraAvatarProps,
} from '@chakra-ui/react';
import { capitalize } from '@common/util/strings';
import { FC } from 'react';

export interface AvatarProps extends ChakraAvatarProps {
    avatar?: string | null;
    firstName?: string | null;
}

const Avatar: FC<AvatarProps> = ({ avatar, firstName, ...props }) => {
    // Use first two letters of first name
    const first2Letters = capitalize(firstName?.slice(0, 2) ?? '');

    return (
        <ChakraAvatar
            size="sm"
            src={avatar ?? undefined}
            name={first2Letters}
            getInitials={() => first2Letters}
            textTransform="none"
            color="white"
            fontWeight="bold"
            {...props}
        />
    );
};

export default Avatar;
